import { useState } from 'react'
import { Alert } from '@indipia/ui-core'

// 스케줄 생성 플로우(현장 선택 · 견적서 업로드 · 공종/공사일 선택) 상단 안내 배너 —
// 화면기획서 B-0/B-1/B-2의 dismissible entry-banner.
// 닫기는 세션 내 로컬 상태일 뿐이라 화면을 다시 들어오면 다시 보인다(기획서와 동일 동작).
//
// 아이콘·닫기 버튼은 공용 Alert 이 갖는다(D-09 §15.10) — 이 래퍼에 남는 것은 닫힘 상태뿐이다.
export function InfoBanner({ children }: { children: React.ReactNode }) {
  const [dismissed, setDismissed] = useState(false)
  if (dismissed) return null
  return (
    <Alert kind="info" style={{ marginBottom: 'var(--gap-md)' }} onClose={() => setDismissed(true)}>
      {/* .alert-body 는 flex-column 이라 자식이 여럿이면 줄이 갈린다 —
          한 덩어리로 감싸 <b>·<strong> 이 인라인으로 남고 문장이 한 줄로 흐르게 한다 */}
      <span>{children}</span>
    </Alert>
  )
}
